import { RouteRecordRaw } from "vue-router";

const spacesRoutes: RouteRecordRaw[] = [
  /**
   * 旧版我的空间,但是内容只负责AI创作资产
   */
  {
    path: "/space",
    name: "space",
    meta: {
      title: "AI创作资产",
      auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/oldspace/index.vue")
  },

  {
    path: "/mypieces",
    name: "myPieces",
    meta: {
      title: "我的资产",
      auth: true,
      useTopbar: true,
      siderGroup: 1,
      layout: "home"
    },
    component: () => import("@/views/space/index.vue")
  }
];

export default spacesRoutes;
